<template>
  <div class="careers-container" data-aos="fade-up">
    <!-- 顶部横幅 -->
    <div class="careers-banner" data-aos="fade-down" data-aos-delay="200">
      <div class="banner-content">
        <h1>加入我们，共创未来</h1>
        <p class="subtitle">我们正在寻找有激情、有才华的你</p>
        <!-- <button
          class="cta-button"
          @click="scrollToPositions"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          查看职位
        </button> -->
      </div>
    </div>

    <!-- 公司优势部分 -->
    <div class="advantages-section" data-aos="fade-up" data-aos-delay="300">
      <h2 class="section-title">为什么选择我们</h2>
      <div class="advantages-grid">
        <div
          class="advantage-card"
          v-for="(item, index) in advantages"
          :key="index"
          data-aos="zoom-in"
          :data-aos-delay="index * 100 + 500"
        >
          <div class="advantage-icon">
            <i :class="item.icon"></i>
          </div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>

    <!-- 职位列表 -->
    <!-- <div
      style="margin-bottom: 32px"
      class="positions-section"
      ref="positionsSection"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      <h2 class="section-title">开放职位</h2>
      <div class="position-list">
        <div
          class="position-card"
          v-for="position in positions"
          :key="position.id"
          data-aos="fade-up"
          :data-aos-delay="position.id * 100 + 800"
        >
          <div class="position-header">
            <h3>{{ position.title }}</h3>
            <span class="position-type">{{ position.type }}</span>
          </div>
          <div class="position-meta">
            <span
              ><i class="el-icon-location"></i> {{ position.location }}</span
            >
            <span><i class="el-icon-clock"></i> {{ position.type }}</span>
          </div>
          <p class="position-desc">{{ position.description }}</p>
          <div class="position-tags">
            <el-tag v-for="tag in position.tags" :key="tag" size="mini">{{
              tag
            }}</el-tag>
          </div>
          <button class="apply-button" @click="showApplyModal(position)">
            立即申请
          </button>
        </div>
      </div>
    </div> -->

    <!-- 申请表单模态框 -->
    <el-dialog title="申请职位" :visible.sync="applyDialogVisible" width="50%">
      <el-form :model="applyForm" label-width="100px">
        <el-form-item label="姓名" required>
          <el-input v-model="applyForm.name"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" required>
          <el-input v-model="applyForm.email" type="email"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="applyForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="简历上传" required>
          <el-upload
            class="resume-upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              支持格式: pdf, doc, docx
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="申请职位">
          <el-input v-model="applyForm.position" disabled></el-input>
        </el-form-item>
        <el-form-item label="自我介绍">
          <el-input
            type="textarea"
            v-model="applyForm.introduction"
            :rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitApplication">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 申请成功提示 -->
    <el-dialog
      title="申请提交成功"
      :visible.sync="successDialogVisible"
      width="30%"
    >
      <p>感谢您的申请！我们已经收到您的信息，会尽快与您联系。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="successDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Careers",
  data() {
    return {
      advantages: [
        {
          icon: "el-icon-trophy",
          title: "产品先发优势",
          description:
            "自主研发团队占比 40%，年研发投入超 100万元。·已获得两项发明专利，5项软件著作权；国家级科技型中小型企业。",
        },
        {
          icon: "el-icon-s-opportunity",
          title: "运营支持体系",
          description:
            "提供从选址到运营的全流程培训（含线上商 学院） 配备专属市场督导，定期驻点帮扶 共享全国性媒体资源，定制区域化营销方案",
        },
        {
          icon: "el-icon-s-flag",
          title: "风险控制机制",
          description:
            "零加盟费政策，降低创业门槛 灵活退换货制度，保障资金安全 按区域划分独家代理权，避免恶性竞争",
        },
        {
          icon: "el-icon-s-data",
          title: "社会价值赋能",
          description:
            "参与 '智慧助老' 公益行动，提升品牌社会形 象 建立用户健康档案，助力国家老龄化战略实施",
        },
      ],
      positions: [
        {
          id: 1,
          title: "前端开发工程师",
          type: "全职",
          location: "北京",
          description: "负责公司前端产品的开发和维护，参与技术方案讨论和实现。",
          tags: ["Vue", "React", "HTML5", "CSS3", "JavaScript"],
        },
        {
          id: 2,
          title: "产品经理",
          type: "全职",
          location: "上海",
          description:
            "负责产品规划、需求分析和用户体验设计，推动产品迭代优化。",
          tags: ["产品规划", "需求分析", "用户体验", "项目管理"],
        },
        {
          id: 3,
          title: "UI设计师",
          type: "全职/实习",
          location: "远程",
          description: "负责产品视觉设计和交互设计，提升用户体验和品牌形象。",
          tags: ["UI设计", "UX设计", "Sketch", "Adobe XD"],
        },
      ],
      applyDialogVisible: false,
      successDialogVisible: false,
      currentPosition: "",
      applyForm: {
        name: "",
        email: "",
        phone: "",
        position: "",
        introduction: "",
      },
      fileList: [],
    };
  },
  methods: {
    scrollToPositions() {
      this.$refs.positionsSection.scrollIntoView({ behavior: "smooth" });
    },
    showApplyModal(position) {
      this.currentPosition = position.title;
      this.applyForm.position = position.title;
      this.applyDialogVisible = true;
    },
    handleExceed(files) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`
      );
    },
    submitApplication() {
      setTimeout(() => {
        this.successDialogVisible = true;
        this.applyDialogVisible = false;
        this.resetApplyForm();
      }, 1000);
    },
    resetApplyForm() {
      this.applyForm = {
        name: "",
        email: "",
        phone: "",
        position: "",
        introduction: "",
      };
      this.fileList = [];
    },
  },
  mounted() {
    // 初始化AOS动画
    import("aos").then((AOS) => {
      AOS.init({
        duration: 600,
        once: true,
      });
    });
  },
};
</script>

<style scoped>
.careers-container {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.careers-banner {
  background: linear-gradient(135deg, #ff9a3d, #f97d01);
  color: white;
  padding: 80px 20px;
  text-align: center;
  border-radius: 8px;
  margin-bottom: 40px;
}

.careers-banner h1 {
  font-size: 36px;
  margin-bottom: 15px;
}

.subtitle {
  font-size: 18px;
  margin-bottom: 25px;
  opacity: 0.9;
}

.cta-button {
  background-color: white;
  color: #f97d01;
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.section-title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 40px;
  color: #333;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.advantage-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.advantage-icon {
  font-size: 40px;
  color: #f97d01;
  margin-bottom: 20px;
}

.advantage-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.position-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 25px;
}

.position-card {
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-left: 4px solid #f97d01;
  transition: all 0.3s;
}

.position-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.position-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.position-header h3 {
  font-size: 20px;
  color: #333;
  margin: 0;
}

.position-type {
  background: #fff4eb;
  color: #f97d01;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.position-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  color: #666;
  font-size: 14px;
}

.position-meta i {
  margin-right: 5px;
}

.position-desc {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
}

.position-tags {
  margin-bottom: 20px;
}

.apply-button {
  width: 100%;
  padding: 10px;
  background: #f97d01;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.apply-button:hover {
  background: #ff9a3d;
}

.resume-upload {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .advantages-grid {
    grid-template-columns: 1fr;
  }

  .position-list {
    grid-template-columns: 1fr;
  }

  .careers-banner h1 {
    font-size: 28px;
  }

  .subtitle {
    font-size: 16px;
  }
}
</style>